import React, { useState, useEffect } from "react";
import { Main, Content } from "../../../components/Layout";
import { Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import api from "../../../services/api";
import IcEditar from "../../../components/Svg/IcEditar";
import IcMais from "../../../components/Svg/IcMais";
import Loading from "../../../components/Loading";
import styles from "./style.module.css";
import useWrapper from "../../../hooks/useWrapper";
import Slct from "../../../components/Slct";
import { InputText } from "../../../components/Input";

export default function TemplateBusiness() {
  const { setbreadcrumb, config } = useWrapper();
  const navigate = useNavigate();
  const [loadingPage, setLoadingPage] = useState(true);
  const [templates, setTemplates] = useState([]);
  const [categories, setcategories] = useState([]);
  const [filter, setfilter] = useState();

  useEffect(() => {
    loadTemplates();

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  async function loadTemplates() {
    const { data: _templates } = await api.get("template-business?active=1", config);
    setTemplates(_templates);

    const { data: _categories } = await api.get("categories?paginate=false", config);
    setcategories(
      _categories
        ?.filter(__category => __category.only_attendance === 0)
        ?.map(__category => ({
          value: __category.id,
          label: __category.name,
        })),
    );
    setLoadingPage(false);
  }

  function redirectEdit(id) {
    navigate(`/business/templatebusiness/edit/${id}`);
  }

  useEffect(() => {
    setbreadcrumb([{ label: "Comercial", url: "/business" }, { label: "Modelos de Orçamentos" }]);
  }, [setbreadcrumb]);

  return (
    <Main>
      <Content>
        {!loadingPage ? (
          <div>
            <Row>
              <Col>
                <h2 className="form-title mb-2">Modelos de orçamentos</h2>
                <p className="sub-title">
                  Crie modelos de orçamentos. Aqui, você pode preparar orçamentos pré-montados com fornecedores,
                  recursos, quantidades e valores específicos, podendo alterá-los como quiser no momento da
                  personalização da proposta para a turma em negociação
                </p>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col sm={4}>
                <span>Modelo</span>
                <InputText
                  value={filter?.template_name || ""}
                  onChange={__ev => {
                    setfilter({
                      ...filter,
                      template_name: __ev.target.value,
                    });
                  }}
                />
              </Col>
              <Col sm={4}>
                <span>Categoria</span>
                <Slct
                  options={[{ value: null, label: "Todas" }].concat(categories || [])}
                  className="w-100"
                  placeholder="..."
                  value={filter?.category || null}
                  onChange={__ev => {
                    setfilter({
                      ...filter,
                      category: __ev.value,
                    });
                  }}
                />
              </Col>
            </Row>
            <Row>
              {templates
                ?.filter(__template =>
                  __template.title.toUpperCase().includes(filter?.template_name?.toUpperCase() || ""),
                )
                ?.filter(__template => !filter?.category || __template.category_id === filter?.category)
                ?.map(__template => (
                  <Col sm={4} key={__template.id} className={styles.cardBusiness}>
                    <div className={`${styles.card}`}>
                      <div>
                        <div className="d-flex justify-content-between">
                          <h3 className="mini-title">{__template.title}</h3>
                          <button type="button" className="simple-ico" onClick={() => redirectEdit(__template.id)}>
                            <IcEditar />
                          </button>
                        </div>
                        <p className="sub-title mt-2">{__template.description}</p>
                      </div>
                      <div className="mt-2">
                        <span className="small-label d-block">
                          <b>{__template.categories.name}</b>
                        </span>
                        <span className="small-label d-block">Criado em: {__template.created_at}</span>
                      </div>
                    </div>
                  </Col>
                ))}
            </Row>
            <Row className="mt-3">
              <Col sm={4}>
                <button
                  type="button"
                  onClick={() => navigate(`/business/templatebusiness/new`)}
                  className={styles.card_new}
                >
                  <div className="content">
                    <div className={styles.icon}>
                      <IcMais />
                    </div>
                    <p>Criar novo modelo</p>
                  </div>
                </button>
              </Col>
            </Row>
          </div>
        ) : (
          <Loading />
        )}
      </Content>
    </Main>
  );
}
